import { reportFetchErrors } from '../../util';

export const fetchTranslationMessages = async (path) => {
  return await reportFetchErrors(fetch(path));
};
